/**
 * signer-core.js — phần dùng chung để KÝ request gửi tới side-server.
 *
 * BẢN GỐC: side-server/clients/signer-core.js. Chép từ side-server@ff8edd8. web-app, CMS và rainichi_mobile
 * chép NGUYÊN file này cùng test/vectors/signature.json. Sửa ở bản gốc, chạy
 * `npm test` của side-server, rồi chép lại — đừng sửa riêng bản chép.
 *
 * ES5, không phụ thuộc gì: chạy trên Node, trình duyệt cũ (CMS nạp bằng thẻ
 * <script>) và Hermes. Thuật toán phải giống src/security/signature.ts từng bước.
 *
 * Chuỗi chuẩn tắc (6 dòng, nối bằng '\n'):
 *   METHOD          in hoa
 *   path            từng đoạn (tách theo `/`) chuẩn hoá: giải ra byte, mã hoá lại
 *   canonicalQuery  key/value chuẩn hoá như path (`+` là dấu cách), GIỮ NGUYÊN thứ tự
 *   bodySha256      sha256 hex của body; rỗng với GET/HEAD/DELETE và body rỗng;
 *                   chữ `multipart` với upload multipart (body không được hash)
 *   timestamp       giây Unix, đã cộng độ lệch giờ với server
 *   nonce           32 hex ngẫu nhiên, mới cho MỖI lần gửi
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.RainichiSignerCore = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var REJECT_HEADER = 'x-signature-reject';
  var NO_BODY_METHODS = { GET: true, HEAD: true, DELETE: true };
  /** bodySha256 của upload multipart — khác '' để không đổi được POST rỗng thành multipart. */
  var MULTIPART_MARKER = 'multipart';

  var K = [
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
  ];

  /** UTF-8 như Buffer.from(text, 'utf8'): surrogate lẻ -> U+FFFD. */
  function utf8Bytes(text) {
    var out = [];
    for (var i = 0; i < text.length; i++) {
      var code = text.charCodeAt(i);
      if (code >= 0xd800 && code <= 0xdbff && i + 1 < text.length) {
        var next = text.charCodeAt(i + 1);
        if (next >= 0xdc00 && next <= 0xdfff) {
          code = 0x10000 + ((code - 0xd800) << 10) + (next - 0xdc00);
          i++;
        } else {
          code = 0xfffd;
        }
      } else if (code >= 0xd800 && code <= 0xdfff) {
        code = 0xfffd;
      }
      if (code < 0x80) {
        out.push(code);
      } else if (code < 0x800) {
        out.push(0xc0 | (code >> 6), 0x80 | (code & 63));
      } else if (code < 0x10000) {
        out.push(0xe0 | (code >> 12), 0x80 | ((code >> 6) & 63), 0x80 | (code & 63));
      } else {
        out.push(0xf0 | (code >> 18), 0x80 | ((code >> 12) & 63), 0x80 | ((code >> 6) & 63), 0x80 | (code & 63));
      }
    }
    return out;
  }

  /** SHA-256 trên mảng byte, trả mảng 32 byte. Không sửa mảng đầu vào. */
  function sha256Bytes(bytes) {
    var length = bytes.length;
    var data = bytes.slice(0);
    data.push(0x80);
    while (data.length % 64 !== 56) data.push(0);
    var high = Math.floor(length / 0x20000000);
    var low = (length * 8) >>> 0;
    data.push(
      (high >>> 24) & 255, (high >>> 16) & 255, (high >>> 8) & 255, high & 255,
      (low >>> 24) & 255, (low >>> 16) & 255, (low >>> 8) & 255, low & 255
    );

    var H = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
    var w = new Array(64);
    for (var offset = 0; offset < data.length; offset += 64) {
      var t;
      for (t = 0; t < 16; t++) {
        var p = offset + 4 * t;
        w[t] = (data[p] << 24) | (data[p + 1] << 16) | (data[p + 2] << 8) | data[p + 3];
      }
      for (t = 16; t < 64; t++) {
        var x = w[t - 15];
        var y = w[t - 2];
        var s0 = ((x >>> 7) | (x << 25)) ^ ((x >>> 18) | (x << 14)) ^ (x >>> 3);
        var s1 = ((y >>> 17) | (y << 15)) ^ ((y >>> 19) | (y << 13)) ^ (y >>> 10);
        w[t] = (w[t - 16] + s0 + w[t - 7] + s1) | 0;
      }
      var a = H[0], b = H[1], c = H[2], d = H[3], e = H[4], f = H[5], g = H[6], h = H[7];
      for (t = 0; t < 64; t++) {
        var S1 = ((e >>> 6) | (e << 26)) ^ ((e >>> 11) | (e << 21)) ^ ((e >>> 25) | (e << 7));
        var ch = (e & f) ^ (~e & g);
        var t1 = (h + S1 + ch + K[t] + w[t]) | 0;
        var S0 = ((a >>> 2) | (a << 30)) ^ ((a >>> 13) | (a << 19)) ^ ((a >>> 22) | (a << 10));
        var maj = (a & b) ^ (a & c) ^ (b & c);
        var t2 = (S0 + maj) | 0;
        h = g; g = f; f = e; e = (d + t1) | 0; d = c; c = b; b = a; a = (t1 + t2) | 0;
      }
      H[0] = (H[0] + a) | 0; H[1] = (H[1] + b) | 0; H[2] = (H[2] + c) | 0; H[3] = (H[3] + d) | 0;
      H[4] = (H[4] + e) | 0; H[5] = (H[5] + f) | 0; H[6] = (H[6] + g) | 0; H[7] = (H[7] + h) | 0;
    }

    var out = [];
    for (var i = 0; i < 8; i++) {
      out.push((H[i] >>> 24) & 255, (H[i] >>> 16) & 255, (H[i] >>> 8) & 255, H[i] & 255);
    }
    return out;
  }

  function toHex(bytes) {
    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
      hex += (bytes[i] < 16 ? '0' : '') + bytes[i].toString(16);
    }
    return hex;
  }

  function sha256Hex(text) {
    return toHex(sha256Bytes(utf8Bytes(String(text))));
  }

  /** HMAC-SHA256; khoá là chuỗi, dùng byte UTF-8 của chuỗi (như createHmac của Node). */
  function hmacSha256Hex(key, message) {
    var keyBytes = utf8Bytes(String(key));
    if (keyBytes.length > 64) keyBytes = sha256Bytes(keyBytes);
    var inner = [];
    var outer = [];
    for (var i = 0; i < 64; i++) {
      var byte = i < keyBytes.length ? keyBytes[i] : 0;
      inner.push(byte ^ 0x36);
      outer.push(byte ^ 0x5c);
    }
    var innerHash = sha256Bytes(inner.concat(utf8Bytes(String(message))));
    return toHex(sha256Bytes(outer.concat(innerHash)));
  }

  var HEX = '0123456789ABCDEF';

  function isHexChar(ch) {
    return /^[0-9A-Fa-f]$/.test(ch);
  }

  /** Ký tự không mã hoá (RFC 3986 unreserved). Mọi byte khác thành %XX in hoa. */
  function isUnreserved(byte) {
    return (byte >= 0x30 && byte <= 0x39) || (byte >= 0x41 && byte <= 0x5a) ||
      (byte >= 0x61 && byte <= 0x7a) || byte === 0x2d || byte === 0x2e || byte === 0x5f || byte === 0x7e;
  }

  /**
   * Chuỗi URL thô -> dãy byte như rawurldecode của PHP: %XX hợp lệ thành byte,
   * `%` hỏng giữ là byte 0x25, ký tự thường thành byte UTF-8, `+` thành dấu cách
   * nếu plusIsSpace (query).
   */
  function percentBytes(text, plusIsSpace) {
    var bytes = [];
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if (ch === '%' && i + 2 < text.length && isHexChar(text.charAt(i + 1)) && isHexChar(text.charAt(i + 2))) {
        bytes.push(parseInt(text.substr(i + 1, 2), 16));
        i += 2;
      } else if (plusIsSpace && ch === '+') {
        bytes.push(0x20);
      } else {
        var end = i + 1;
        var code = text.charCodeAt(i);
        if (code >= 0xd800 && code <= 0xdbff && i + 1 < text.length) {
          var next = text.charCodeAt(i + 1);
          if (next >= 0xdc00 && next <= 0xdfff) end = i + 2;
        }
        var encoded = utf8Bytes(text.slice(i, end));
        for (var k = 0; k < encoded.length; k++) bytes.push(encoded[k]);
        i = end - 1;
      }
    }
    return bytes;
  }

  function percentEncodeBytes(bytes) {
    var out = '';
    for (var i = 0; i < bytes.length; i++) {
      var byte = bytes[i];
      out += isUnreserved(byte) ? String.fromCharCode(byte) : '%' + HEX.charAt(byte >> 4) + HEX.charAt(byte & 15);
    }
    return out;
  }

  /**
   * Một thành phần URL ở dạng chuẩn: giải ra byte rồi mã hoá lại. Hai cách viết ra
   * cùng chuỗi khi và chỉ khi PHP giải ra cùng dãy byte.
   */
  function normalizeComponent(text, plusIsSpace) {
    return percentEncodeBytes(percentBytes(text, plusIsSpace));
  }

  /**
   * Tách theo `/` thật rồi chuẩn hoá từng đoạn: `%2F` trong một đoạn vẫn là `%2F`
   * (không gộp hai route), `%0A` không chèn được dòng vào chuỗi chuẩn tắc.
   */
  function canonicalPath(path) {
    var segments = path.split('/');
    for (var i = 0; i < segments.length; i++) {
      segments[i] = normalizeComponent(segments[i], false);
    }
    return segments.join('/');
  }

  /** KHÔNG sắp xếp: PHP lấy giá trị cuối khi key lặp, đổi thứ tự là đổi nghĩa. */
  function canonicalQuery(urlOrSearch) {
    var text = String(urlOrSearch || '');
    var question = text.indexOf('?');
    if (question === -1) return '';
    var raw = text.slice(question + 1);
    var hash = raw.indexOf('#');
    if (hash !== -1) raw = raw.slice(0, hash);

    var out = [];
    var pieces = raw.split('&');
    for (var i = 0; i < pieces.length; i++) {
      var piece = pieces[i];
      if (piece === '') continue;
      var equals = piece.indexOf('=');
      var key = equals === -1 ? piece : piece.slice(0, equals);
      var value = equals === -1 ? '' : piece.slice(equals + 1);
      out.push(normalizeComponent(key, true) + '=' + normalizeComponent(value, true));
    }
    return out.join('&');
  }

  /** Tách URL tuyệt đối (hoặc path) thành path và search ('?...'), bỏ fragment. */
  function splitUrl(url) {
    var text = String(url || '');
    var origin = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^\/?#]*/.exec(text);
    var rest = origin ? text.slice(origin[0].length) : text;
    var hash = rest.indexOf('#');
    if (hash !== -1) rest = rest.slice(0, hash);
    var question = rest.indexOf('?');
    var path = question === -1 ? rest : rest.slice(0, question);
    return { path: path === '' ? '/' : path, search: question === -1 ? '' : rest.slice(question) };
  }

  /**
   * Khớp middleware của server: multipart ký bằng dấu riêng, không hash body.
   * Body không phải chuỗi (Buffer, object, ArrayBuffer...) thì ném lỗi: trước đây
   * nó bị coi là rỗng, client ký hash rỗng rồi vẫn gửi body thật — server từ chối
   * 401 mà không ai hiểu vì sao. Gọi nơi đây phải tự chuyển body thành chuỗi.
   */
  function bodySha256(method, body, multipart) {
    if (NO_BODY_METHODS[String(method).toUpperCase()]) return '';
    if (multipart) return MULTIPART_MARKER;
    if (body === null || body === undefined || body === '') return '';
    if (typeof body !== 'string') throw new Error('signer-core: body phải là chuỗi (hoặc null/undefined)');
    return sha256Hex(body);
  }

  function canonicalString(parts) {
    var split = splitUrl(parts.url);
    return [
      String(parts.method).toUpperCase(),
      canonicalPath(split.path),
      canonicalQuery(split.search),
      parts.bodySha256 || '',
      String(parts.timestamp),
      String(parts.nonce)
    ].join('\n');
  }

  function signRequest(options) {
    var method = String(options.method || 'GET').toUpperCase();
    var hash = bodySha256(method, options.body, options.multipart);
    var canonical = canonicalString({
      method: method,
      url: options.url,
      bodySha256: hash,
      timestamp: options.timestamp,
      nonce: options.nonce
    });
    var headers = {
      'X-Signature': options.sign(canonical),
      'X-Signature-Key': options.keyId,
      'X-Signature-Timestamp': String(options.timestamp),
      'X-Signature-Nonce': String(options.nonce)
    };
    if (hash && hash !== MULTIPART_MARKER) headers['X-Content-SHA256'] = hash;
    return headers;
  }

  /**
   * Giờ theo server: đọc header Date của mọi response API, lưu độ lệch. Máy để
   * sai giờ quá TTL (300 giây) mà không chỉnh thì mọi request bị chặn `expired`.
   */
  function createClock(nowMs) {
    var now = nowMs || function () { return Date.now(); };
    var offsetMs = 0;
    return {
      observe: function (dateHeader) {
        if (!dateHeader) return;
        var serverMs = Date.parse(dateHeader);
        if (!isNaN(serverMs)) offsetMs = serverMs - now();
      },
      timestamp: function () {
        return String(Math.floor((now() + offsetMs) / 1000));
      },
      offsetMs: function () {
        return offsetMs;
      }
    };
  }

  function randomNonce() {
    var source = null;
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) source = crypto;
    else if (typeof msCrypto !== 'undefined' && msCrypto.getRandomValues) source = msCrypto;
    var bytes = [];
    var i;
    if (source && typeof Uint8Array !== 'undefined') {
      var buffer = new Uint8Array(16);
      source.getRandomValues(buffer);
      for (i = 0; i < 16; i++) bytes.push(buffer[i]);
    } else {
      for (i = 0; i < 16; i++) bytes.push(Math.floor(Math.random() * 256));
    }
    return toHex(bytes);
  }

  return {
    REJECT_HEADER: REJECT_HEADER,
    MULTIPART_MARKER: MULTIPART_MARKER,
    sha256Hex: sha256Hex,
    hmacSha256Hex: hmacSha256Hex,
    normalizeComponent: normalizeComponent,
    canonicalPath: canonicalPath,
    canonicalQuery: canonicalQuery,
    splitUrl: splitUrl,
    bodySha256: bodySha256,
    canonicalString: canonicalString,
    signRequest: signRequest,
    createClock: createClock,
    randomNonce: randomNonce,
    toHex: toHex
  };
});
